const TabList = [
    {
        title: "Profile",
        tabIndex: 0,
    },
    {
        title: "MyPass",
        tabIndex: 4,
    },
    {
        title: "Recruitment",
        tabIndex: 5,
    },
    {
        title: "Mobilisation",
        tabIndex: 17,
    },
    {
        title: "Availability",
        tabIndex: 14,
    },
    {
        title: "Identifiers",
        tabIndex: 12,
    },
    {
        title: "Documents",
        tabIndex: 8,
    },
    {
        title: "Communication",
        tabIndex: 9,
    },
    {
        title: "Employment History",
        tabIndex: 11,
    },
    // {
    //     title: "Project Specific Attribute",
    //     tabIndex: 10,
    // },
    // {
    //     title: "Flights",
    //     tabIndex: 16,
    // },
    {
        title: "Activities",
        tabIndex: 13,
    },
    // {
    //     title: "Positions",
    //     tabIndex: 15,
    // },
    // {
    //     title: "Site Access",
    //     tabIndex: 18,
    // },
    // {
    //     title: "Training History",
    //     tabIndex: 19,
    // },
];

export default TabList;
